import { Equipo } from '../Equipo/Equipo';
import { Jugador, JugadorJSON } from '../Jugador/Jugador';
import { Temporada } from '../Temporada/Temporada';

export interface JugadorXEquipoJSON {
  jxe_id: string | null;
  jxe_jugid: number;
  jxe_eqid: number;
  jxe_activo: boolean;
  jxe_temid: number;
  jugador: JugadorJSON;
  jxe_fecha_desactivacion: Date | null;
}

export class JugadorXEquipo {
  protected constructor(
    private id: string | null,
    private jugid: number,
    private eqid: number,
    private activo: boolean,
    private temid: number,
    private jugador: Jugador,
    private fechaDesactivacion: Date | null,
  ) {}

  static createFrom(
    id: string | null,
    jugid: number,
    eqid: number,
    activo: boolean,
    temid: number,
    jugador: Jugador,
    fechaDesactivacion: Date | null,
  ) {
    return new this(id, jugid, eqid, activo, temid, jugador, fechaDesactivacion);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id == anId;
  }

  isIdentifiedAs(aEntity: JugadorXEquipo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: JugadorXEquipoJSON) {
    return JugadorXEquipo.createFrom(
      entity.jxe_id,
      entity.jxe_jugid,
      entity.jxe_eqid,
      entity.jxe_activo,
      entity.jxe_temid,
      Jugador.fromJSON(entity.jugador),
      entity.jxe_fecha_desactivacion,
    );
  }

  toJSON(): JugadorXEquipoJSON {
    return {
      jxe_id: this.getId(),
      jxe_jugid: this.getJugid(),
      jxe_eqid: this.getEqid(),
      jxe_activo: this.getActivo(),
      jxe_temid: this.getTemid(),
      jugador: this.getJugador().toJSON(),
      jxe_fecha_desactivacion: this.getFechaDesactivacion(),
    };
  }

  static createForEquipo(temporada: Temporada, jugador: Jugador, equipoId: number) {
    return JugadorXEquipo.createFrom(
      'new',
      Number(jugador.getId()),
      equipoId,
      true,
      Number(temporada.getId()),
      jugador,
      null,
    );
  }

  getId(): string | null {
    return this.id;
  }

  getJugid(): number {
    return this.jugid;
  }

  getEqid(): number {
    return this.eqid;
  }

  getActivo(): boolean {
    return this.activo;
  }

  getTemid(): number {
    return this.temid;
  }

  getJugador(): Jugador {
    return this.jugador;
  }

  getFechaDesactivacion(): Date | null {
    return this.fechaDesactivacion;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setJugid(value: number): void {
    this.jugid = value;
  }

  setEqid(value: number): void {
    this.eqid = value;
  }

  setActivo(value: boolean): void {
    this.activo = value;
  }

  setTemid(value: number): void {
    this.temid = value;
  }

  setFechaDesactivacion(value: Date): void {
    this.fechaDesactivacion = value;
  }
}
